import { useEffect, useState } from "react";

const HAND_OFF_EVENT = "crx:hand-off";

/** Tell the pages already on screen that something was handed over to them (a draft, a price or fleet list). */
export const signalHandOff = (): void => {
    window.dispatchEvent(new Event(HAND_OFF_EVENT));
};

/**
 * A number that changes each time something is handed over — a page that's
 * already open (Ask's "Fill with AI: this provider's rates" on the provider
 * you're on) puts it in its take effect's dependencies to check again.
 */
export const useHandOffSignal = (): number => {
    const [tick, setTick] = useState(0);
    useEffect(() => {
        const handle = () => setTick((value) => value + 1);
        window.addEventListener(HAND_OFF_EVENT, handle);
        return () => window.removeEventListener(HAND_OFF_EVENT, handle);
    }, []);
    return tick;
};
